import { render, staticRenderFns } from "./PurchaseOrderItemsReservationTable.vue?vue&type=template&id=2311d4c3&scoped=true"
import script from "./PurchaseOrderItemsReservationTable.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderItemsReservationTable.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderItemsReservationTable.vue?vue&type=style&index=0&id=2311d4c3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2311d4c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2311d4c3')) {
      api.createRecord('2311d4c3', component.options)
    } else {
      api.reload('2311d4c3', component.options)
    }
    module.hot.accept("./PurchaseOrderItemsReservationTable.vue?vue&type=template&id=2311d4c3&scoped=true", function () {
      api.rerender('2311d4c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchase-orders/PurchaseOrderItemsReservationTable.vue"
export default component.exports